import { CORREO_PERSONAL_PENDIENTE, TELEFONO_PERSONAL_PENDIENTE } from '@/const'

function esCorreoFaltante(correo) {
  if (correo === null || correo === undefined) return true
  const normalizado = String(correo).trim().toUpperCase()
  if (normalizado === '') return true
  return normalizado === CORREO_PERSONAL_PENDIENTE
}

function esTelefonoIndividualVacio(telefono) {
  if (telefono === null || telefono === undefined) return true
  const soloDigitos = String(telefono).replace(/\D/g, '')
  if (soloDigitos === '') return true
  return soloDigitos === TELEFONO_PERSONAL_PENDIENTE
}

export function detectarDatosFaltantesContacto(contacto) {
  const seguro = contacto || {}
  const correoFaltante = esCorreoFaltante(seguro.correoElectronico)
  const telefonoFaltante =
    esTelefonoIndividualVacio(seguro.telefonoCelular) && esTelefonoIndividualVacio(seguro.telefonoFijo)
  return {
    correoFaltante,
    telefonoFaltante,
    algunoFaltante: correoFaltante || telefonoFaltante,
  }
}
